"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var account_1 = tslib_1.__importDefault(require("./account"));
var feecategory_1 = tslib_1.__importDefault(require("./feecategory"));
var client_1 = tslib_1.__importDefault(require("./client"));
var project_1 = tslib_1.__importDefault(require("./project"));
var billableitem_1 = tslib_1.__importDefault(require("../transactions/billableitem"));
var state_1 = tslib_1.__importDefault(require("./state"));
var wcclassification_1 = tslib_1.__importDefault(require("./wcclassification"));
var employeetype_1 = tslib_1.__importDefault(require("./employeetype"));
var schedule_1 = tslib_1.__importDefault(require("./schedule"));
var occcode_1 = tslib_1.__importDefault(require("./occcode"));
var productiontype_1 = tslib_1.__importDefault(require("./productiontype"));
var paycode_1 = tslib_1.__importDefault(require("./paycode"));
var paycodetype_1 = tslib_1.__importDefault(require("./paycodetype"));
var actualfeerate_1 = tslib_1.__importDefault(require("./actualfeerate"));
var vendor_1 = tslib_1.__importDefault(require("./vendor"));
var FeeResource = /** @class */ (function (_super) {
    tslib_1.__extends(FeeResource, _super);
    function FeeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeeResource.endpoint = '/fees';
    FeeResource.MODEL_NAME = 'fee';
    FeeResource.related = {
        overrides: FeeResource,
        trigger_fee: FeeResource,
        account: account_1.default,
        account_offset: account_1.default,
        categories: feecategory_1.default,
        client: client_1.default,
        project: project_1.default,
        // assignment: AssignmentResource, --circular
        billable_item: billableitem_1.default,
        //city: CityResource ???
        work_states: state_1.default,
        hire_states: state_1.default,
        resident_states: state_1.default,
        wc_classification: wcclassification_1.default,
        employee_type: employeetype_1.default,
        schedule: schedule_1.default,
        occ_code: occcode_1.default,
        production_type: productiontype_1.default,
        excluded_paycodes: paycode_1.default,
        excluded_paycode_types: paycodetype_1.default,
        actual_rate: actualfeerate_1.default,
        vendor: vendor_1.default,
    };
    return FeeResource;
}(base_1.default));
exports.default = FeeResource;
//# sourceMappingURL=fee.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/fee.js
// module id = FO0z
// module chunks = 0